$(document).ready(function(){
    function imageToyPOPup(){
        $('.block_toy-bottom-image-popup-image-list').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            fade: true,
            prevArrow: $(".block_toy-bottom-image-arrow-left"),
            nextArrow: $(".block_toy-bottom-image-arrow-right")
        });
    }
    
    $(document).on("click",".block_toy-bottom-inner-blocks",function(){
        $("body").addClass("overflow-hidden");
        $(".block_toy-bottom-image-popups").css("display","flex");
        var data_id = $(this).attr("data_id");
        if($('.block_toy-bottom-image-popup-image-list').hasClass("slick-initialized")){
            $('.block_toy-bottom-image-popup-image-list').slick('unslick');
        }
        imageToyPOPup();
        var data_index = $(".block_toy-bottom-image-popup-image#block_"+data_id).attr("data-slick-index");
        $('.block_toy-bottom-image-popup-image-list').slick('slickGoTo', data_index);
    });
    $(document).on("click",".block_toy-bottom-image-popup-close",function(){
        $("body").removeClass("overflow-hidden");
        $(".block_toy-bottom-image-popups").css("display","none");
    });
    $(document).on('click', 'body', function(e){
        var target = e.target;
        if($(".block_toy-bottom-image-popups").is(e.target)){
            $("body").removeClass("overflow-hidden");
            $(".block_toy-bottom-image-popups").css("display","none");
        }
    });
});